import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { UserState, UserType } from './userTypes'

const initialState: UserState = {
  selectedUser: null,
  users: []
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setSelectedUser(state, action: PayloadAction<UserState['selectedUser']>) {
      state.selectedUser = action.payload
    },
    setUsers(state, action: PayloadAction<UserType[]>) {
      state.users = action.payload
    }
  }
})

export const userReducer = userSlice.reducer
